import {
  BaseHubBlock,
  flattenTipTapNodes,
  stateToJson,
} from '@basehub/tiptap-api-utils'

// note: can't import as it would be a circular dependency
// import type { Block, RichTextBlock } from '@basehub/data/replicache/index'
type RichTextBlock = any
type Block = any

/* Type declarations */
export function isInstanceInRichText(
  richText: RichTextBlock,
  block: Block,
  getKeys: (sourceBlockId: string) => string[]
): boolean
export function isInstanceInRichText(
  richText: RichTextBlock,
  block: Block,
  getKeys: (sourceBlockId: string) => Promise<string[]>
): Promise<boolean>

/* Implementation */
export function isInstanceInRichText(
  richText: RichTextBlock,
  block: Block,
  getKeys: (sourceBlockId: string) => string[] | Promise<string[]>
): boolean | Promise<boolean> {
  const result = getKeys(richText.sourceBlockId || richText.id)

  if (result instanceof Promise) {
    return result.then((keys) =>
      keys.some((cId) => cId === block.id || cId === block.sourceBlockId)
    )
  }

  return result.some((cId) => cId === block.id || cId === block.sourceBlockId)
}

export const getInstancesInRichTextById = (
  richText: RichTextBlock['value']['state'],
  id: string
) => {
  const json = stateToJson(richText)
  const flattenedNodes = flattenTipTapNodes(json.content as any)
  const instanceIds = new Set<string>()
  flattenedNodes.forEach((node) => {
    if (node.type === BaseHubBlock.name && node.attrs?.id === id) {
      instanceIds.add(node.attrs.id)
    } else if (node.marks) {
      node.marks.forEach((mark) => {
        if (mark?.attrs?.id === id) {
          instanceIds.add(mark.attrs.id)
        }
      })
    }
  })
  return [...instanceIds]
}

export const getInstancesInRichText = (
  richText: RichTextBlock['value']['state'],
  prefetchedJson?: ReturnType<typeof stateToJson>
) => {
  const instanceIds = new Set<string>()

  const json = prefetchedJson ?? stateToJson(richText)
  const flattenedNodes = flattenTipTapNodes(json.content as any)
  flattenedNodes.forEach((node) => {
    if (node.type === BaseHubBlock.name) {
      instanceIds.add(node.attrs?.id)
    } else if (node.marks) {
      node.marks.forEach((mark) => {
        if (mark?.attrs?.id) {
          instanceIds.add(mark.attrs.id)
        }
      })
    }
  })
  return [...instanceIds]
}
